const envConfig = {
  nodeEnv: process.env.REACT_APP_NODE_ENV
};

export default envConfig;
